import { PdpDesktopDetailRow } from './PdpDesktopDetailRow';

interface PdpDesktopMetalDetailsProps {
  goldPurity: string | null;
  metal: string;
  metalWeight: number;
  onInfoIconClick?: (label: string) => void;
}

const WEIGHT_VARIATION_TEXT =
  'The final invoice amount will be adjusted in case of variation in weight.';

function getMetalDisplayName(metal: string): string {
  return metal === 'Gold' ? 'Gold' : metal;
}

export function PdpDesktopMetalDetails({
  goldPurity,
  metal,
  metalWeight,
  onInfoIconClick,
}: PdpDesktopMetalDetailsProps) {
  return (
    <>
      {goldPurity ? (
        <PdpDesktopDetailRow
          label="Type"
          value={`${goldPurity} ${getMetalDisplayName(metal)}`}
        />
      ) : null}
      {metalWeight > 0 ? (
        <PdpDesktopDetailRow
          label="Weight"
          value={`${metalWeight} gram`}
          tooltip={WEIGHT_VARIATION_TEXT}
          onInfoIconClick={onInfoIconClick}
        />
      ) : null}
    </>
  );
}
